import { render, staticRenderFns } from "./CustomRating.vue?vue&type=template&id=d8246156"
import script from "./CustomRating.vue?vue&type=script&lang=js"
export * from "./CustomRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports